/**
 * `sortBy` values the Clerk Review queue grid sends to `/clerk-review/query`.
 * Strings match the API SortBy names (CourtName → courtName, etc.) until the
 * OpenAPI contract exposes a typed enum.
 */
export enum CLERK_REVIEW_SORT_COLUMN {
  COURT_NAME = 'courtName',
  FILING_ID = 'filingId',
  DATE_RANGE = 'dateRange',
  JUDGE_NAME = 'judgeName',
  CASE_NUMBER = 'caseNumber',
  AUTHORIZER_NAME = 'authorizerName',
  FILING_TYPE = 'filingType',
  DOCUMENT_TITLE = 'documentTitle',
  STATUS = 'status',
}
